'use client'

import type { Common } from '@cruz-com/lookup'
import { Radio, RadioGroup } from '@headlessui/react'
import _ from 'lodash'
import { twMerge } from 'tailwind-merge'

type Props = {
  name: string
  option: Common.Option[]
  value: number
  onChange: (val: number) => void
} & Omit<React.ComponentPropsWithoutRef<'div'>, 'onChange'>

const defaultStyle = 'px-3 py-1.5 flex items-center h-10 text-base md:text-sm font-medium transition-all duration-300'
const radioButtonStyle = twMerge(defaultStyle, 'cursor-pointer hover:bg-zinc-200/70', 'dark:hover:bg-zinc-800 dark:hover:text-zinc-100')
const activeStyle = twMerge(defaultStyle, 'cursor-default bg-zinc-100 dark:bg-zinc-700 shadow-inner')

export function RadioButtons({ name, option, value, onChange, ...rest }: Props) {
  return (
    <RadioGroup
      name={name}
      value={value}
      onChange={(val) => onChange(_.toNumber(val))}
      className='flex w-fit items-center divide-x rounded border border-zinc-300 dark:border-zinc-700'
      aria-label={rest['aria-label'] || name}
      {...rest}
    >
      {_.map(option, (d) => {
        const { id, name, count } = d
        return (
          <Radio
            key={id}
            value={id}
            className={twMerge(value?.toString() === id?.toString() ? activeStyle : radioButtonStyle)}
            aria-label={typeof name === 'string' ? name : ''}
          >
            {name}
            {count && (
              <span className='ml-1 font-light' aria-hidden='true'>
                ({count})
              </span>
            )}
          </Radio>
        )
      })}
    </RadioGroup>
  )
}
